import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var tabbedPanelContainer = {
  name: "i9gxme",
  styles: "flex-grow:1;"
};
export var tabPanel = {
  name: "1yuhvjn",
  styles: "margin-top:16px;"
};
export var modalContents = {
  name: "19midj6",
  styles: "padding:16px;"
};
export var footer = /*#__PURE__*/css("width:100%;border-top:1px solid ", colors.neutral.trim.default, ";");
export var footerButton = {
  name: "zdpt2t",
  styles: "margin-left:auto;"
};
export var fakeTabbable = {
  name: "19tiwwo",
  styles: "font-size:0;position:absolute;left:-10px;opacity:0;"
};
export var footerLink = /*#__PURE__*/css(designTokenFonts.bodyBold, " color:", colors.interactive.base.default, ";");
export var modalCloseIcon = /*#__PURE__*/css("color:", colors.interactive.base.default, ";");
export var footerLinkIcon = /*#__PURE__*/css("color:", colors.interactive.base.default, ";");